
import Vue from "vue";
import { worker } from "@/@modules/fseg/services/store/worker";

export default Vue.extend({
  props: {},
  data() {
    return {
      ibanForm: {
        // iban && bic are be undefined when all chars in field are deleted
        iban: "" as string | undefined,
        bic: "" as string | undefined,
      },
      isSameIbanIntroduced: false,
      isValid: false,
    };
  },
  computed: {
    isFormValid(): boolean {
      return !!this.ibanForm.iban && (this.isNotBeIban ? !!this.ibanForm.bic : true) && this.isValid;
    },
    isNotBeIban(): boolean {
      const twoFisrtChars = this.ibanForm.iban?.slice(0, 2);
      return twoFisrtChars?.length === 2 && !twoFisrtChars.match(/^BE/i);
    },
  },
  methods: {
    format(data: string | undefined) {
      return data?.toUpperCase().replaceAll(" ", "");
    },
    formatBic() {
      this.ibanForm.bic = this.format(this.ibanForm.bic);
    },
    formatIban() {
      this.ibanForm.iban = this.format(this.ibanForm.iban);
    },
    submit() {
      if (this.ibanForm.iban === worker.data?.foreignBankAccount?.iban) {
        this.isSameIbanIntroduced = true;
      } else {
        this.$emit("continueIbanEdit", this.ibanForm);
      }
    },
  },
});
